<template>
    <div class="expertQuestionDetail" v-show="detailShow">
        <span class="gobackBtn2" @click="goBack"><img src="../../../assets/images/home/back.png" alt=""></span>
        <!-- 问题标题 -->
        <div class="question_top">
            <span class="gobackBtn" @click="goBack"><van-icon name="arrow-left"/></span>
            <h1 class="title">{{detailParams.question}}</h1>
            <div class="tag_look_coll">
                <span class="tag" v-for="tlist in getTagList(detailParams.tlist)" :key="tlist.id">{{tlist.name}}</span>
                <span class="looknum">{{fomatterNum(detailParams.pageViews)}}阅读</span>
                <span class="collect addColl" v-show="!collectShow" @click="collect(true)"></span>
                <span class="collect cancelColl" v-show="collectShow" @click="collect(false)"></span>
            </div>
        </div>
        <!-- 问题回答 -->
        <div class="answer_bottom">
            <div class="expert_info" @click.stop="toExpert(detailParams)">
                <span class="tx" :style="{backgroundImage:'url('+getExpert(detailParams).headImageUrl+')'}"></span>
                <div class="ex_right">
                    <span class="name">{{getExpert(detailParams).realName}}</span><br/>
                    <span class="position">{{getExpert(detailParams).hospital}}{{getExpert(detailParams).position}}</span>
                </div>
            </div>
            <p class="answer_text">{{detailParams.answer}}</p>
            <p class="more_question" @click="toQuestionList">更多相似问题（ {{detailParams.sameTypeNum > 1000 ? '999+' : detailParams.sameTypeNum}} ）></p>
        </div>
        <!-- 分享关注引导 -->
        <share-guide @shareGio="gioShare"></share-guide>
    </div>
</template>

<style lang="less" scoped>
.expertQuestionDetail{
    min-height: 100%;
    padding-bottom: 57px;
    .gobackBtn2{
        display: none;
        position: fixed;
        width: 26px;
        height: 25px;
        top: 10px;
        left: 7px;
        img{
            width: 26px;
            height: 26px;
        }
    }
    .question_top{
        padding: 20px 12px 16px;
        margin-bottom: 8px;
        background: @expertFontColor255;
        span.gobackBtn{
            width:10px;
            display: inline-block;
            float: left;
            font-size:@indexFontSize20;
            color: @expertFontColor51;
            position: absolute;
            top: 19px;
            left: 12px;
            .van-icon{
                vertical-align: top;
                margin-top: 3px;
            }
        }
        .title{
            padding-left: 20px;
            font-size: @indexFontSize18;
            font-weight: 500;
            color: @expertFontColor51;
            line-height: 27px;
            margin-bottom: 20px;
        }
        .tag_look_coll{
            position: relative;
            .tag{
                padding: 4px;
                border-radius:4px;
                border:1px solid @mainColor;
                font-size:@indexFontSize12;
                color:@mainColor;
                line-height:12px;
                display: inline-block;
                margin-right: 4px;
            }
            .looknum{
                font-size:@indexFontSize12;
                color: @expertFontColor153;
            }
            .collect{
                float: right;
                width: 28px;
                height: 35px;
                display: block;
                position: absolute;
                right: 0;
                top:0;bottom:0;
                margin:auto;
            }
            .addColl{
                background: url(../../../assets/images/icon/collect.png) no-repeat center center;
                background-size: 20px;
            }
            .cancelColl{
                background: url(../../../assets/images/icon/cancelColl.png) no-repeat center center;
                background-size: 28px;
            }
        }
    }
    .answer_bottom{
        padding: 16px 12px 12px;
        background: @expertFontColor255;
        .expert_info{
            overflow: hidden;
            .tx{
                width: 40px;
                height: 40px;
                border-radius: 50%;
                background: #eee;
                display: inline-block;
                margin-right: 3px;
                float: left;
                background-position: center center;
                background-repeat: no-repeat;
                background-size: cover;
            }
            .ex_right{
                width: 308px;
                float: left;
                font-size:@indexFontSize12;
                line-height: 18px;
                margin-top: 2px;
                .name{
                    color: #333333;
                }
                .position{
                    color: #999999;
                }
            }
        }
        .answer_text{
            font-size:@indexFontSize14;
            font-weight: 400;
            color: @expertFontColor51;
            line-height: 22px;
            padding: 16px 0;
            border-bottom: 1px solid @expertBorderColor242;
        }
        .more_question{
            margin-top: 16px;
            text-align: center;
            font-size:@indexFontSize14;
            font-weight: 500;
            a{
                color: @expertFontColor51;
            }
        }
    }
}
</style>

<script>
import { fomatterNum,getCookie,is_weixin, getUrlParamsByName } from "@/assets/js/common.js";
import shareGuide from "@/components/common/shareGuide.vue";
var start_time = new Date();
//定义起始时间
var end_time = "" ;
//定义结束时间
var loadTime = ''
window.onload = function(){
	end_time = new Date();
  return loadTime = end_time.getTime() - start_time.getTime()
}
export default {
    name:"questionDetail",
    components: {
        shareGuide,
    },
    data(){
        return{
            collectShow: false,
            detailId: this.$route.params.detailId,
            detailParams:{},
            userInfo:{},
            detailShow:false,
            curCollType:true,
            logged:null, //1代表微信中在别的页面没有授权过
            handleParams:{
                type:"expertAdd",number:this.$route.params.detailId
            },
            taskfinish:{},
            taskfinishcollect:{},
            labelName:'',
            flag:true,
            arr:[],
            itemSetId: '',
            sceneId: '',
            lookTimer: null,
            readingTime: 0,
        }
    },

    beforeRouteEnter(to,from,next){
        next(vm=>{
            // 如果不是在注册页返回的，走原有的流程，否则停留在当前页面
            if(!getUrlParamsByName('fromLogin')){
                vm.wxJsSet.wxLoginFn(vm,vm.handleParams,function(){
                    if(!vm.collectShow && vm.$route.query.expertAdd==localStorage.getItem("expertAdd")){
                        vm.collectAjax();
                    }else{
                        localStorage.removeItem("expertAdd");
                    }
                });
            }
        })
    },
    beforeRouteLeave(to, from, next) {
    if (to.name == "expertOnlineList"  && this.flag) {
      this.$store.commit("changeIncludes", ["home","expertOnlineList"]);
    }else if(to.name == "expertDetail"){
      this.$store.commit("changeIncludes", ['expertDetail','expertOnlineList']);
    }else{
      this.$store.commit("changeIncludes", ['home']);
    }
    next();
  },
    mounted(){
        this.getDetail();
        this.durationTime();
        this.getShopId();

        if(localStorage.getItem("userInfo")!=null && localStorage.getItem("userInfo")!="" && JSON.parse(localStorage.getItem("userInfo")).mobile !=null && JSON.parse(localStorage.getItem("userInfo")).mobile !=""){
            this.userInfo=JSON.parse(localStorage.getItem("userInfo"));
            this.checkCollect();
        }
        $(window).scroll(function() {
            var top1 = $('.question_top').offsetTop;
            var top2 = $(document).scrollTop();
            var top = top1-top2;
            if (top <= 0) {
                let t1 = 0;
                let t2 = 0;
                let lookT= null; // 定时器
                // scroll监听
                document.onscroll = function() {
                    clearTimeout(timer);
                    timer = setTimeout(isScrollEnd, 300);
                    t1 = document.documentElement.scrollTop || document.body.scrollTop;
                    }

                    function isScrollEnd() {
                    t2 = document.documentElement.scrollTop || document.body.scrollTop;
                    if(t2 == t1){
                        console.log('滚动结束了')
                    }else{
                        console.log('滚动中')
                    }
                }
                $('.gobackBtn2').css({'display':'inline-block'})
            }else{
                $('.gobackBtn2').css('display','none')
            }
        })
    },
    destroyed() {
      this.durationTimeReport()
      clearTimeout(this.lookTimer);
    },
    methods:{
        fomatterNum,
        is_weixin,
        getCookie,
        // 获取问答详情
        getDetail: function (){
            var tagListTitle = ['四季','常见疾病','喂养攻略','日常护理','教育','生长发育','睡眠','亲子关系','育儿内容']
            var class1 = []
            var class2 = ''
            this.$http.get("/expert/v3/expertAnswerDetail", {id: this.detailId}, res => {
                if (res.code == 200) {
                    this.detailParams = res.data;
                    this.detailParams.tlist.forEach(item=>{
                        this.arr.push(item.name)
                    })
                    this.detailShow = true;
                    sensors.track("EnterQuestionPage", {
                        last_source:localStorage.getItem('question_source'),
                        key_word: localStorage.getItem('question_keyword') || '',
                        click_position: parseInt(localStorage.getItem('question_position')) || '',
                        question_class1:this.detailParams.ptagNames,
                        question_class2: this.arr.toString(),
                        question_id:this.$route.params.detailId,
                        question_name:this.detailParams.question,
                        loaded_time:loadTime,
                        expert_name:this.detailParams.expert.realName,
                        expert_hospital:this.detailParams.expert.hospital,
                        expert_level:this.detailParams.expert.position
                    });
                    this.tagName = this.detailParams.tlist[0].name
                    var labelArry=[];
                    if(this.detailParams.tagList!=null && this.detailParams.tagList.length!=0){
                        this.detailParams.tagList.forEach((item)=>{
                            labelArry.push(item.name);
                        })
                        this.labelName=labelArry.join("，");
                    }
                    gio('page.set', {'QATitle_pvar': res.data.question});
                    gio('track', 'QADetailPageView',{'QATitle_var':res.data.question, 'QALabel_var':this.labelName});
                    var that=this;
                    var shareDataParams={
                        shareLink: location.href.split('#')[0],
                        shareDesc: this.detailParams.answer,
                        shareTitle: this.detailParams.question,
                        imgUrl: "https://image-mom.feihe.com/wxshare/home.png",//必须是绝对路径
                        shareGioFn:function(){
                            gio('track', 'QAShareSuccessClick',{'QATitle_var':that.detailParams.question, 'QALabel_var':that.labelName});
                        },
                        contentId:this.detailId,
                        babyShow: true,
                        source: 'question',
                    }
                    this.wxJsSet.wxShare("fx",shareDataParams,this);
                }
            });
        },
        // 点击查看专家
        toExpert:function(item){
            console.log(this.detailParams)
            this.$router.push({path:'/expertOnline/expertLists/'+this.detailParams.expert.id})
        },
        // 返回上一页
        goBack:function(){
            if(window.history.length >1 && this.getCookie("fromPath")){
                  this.$router.go(-1)
            }else{
                this.$router.push('/expertOnline')
            }
            // this.$router.push('/expertOnline')
        },
        // 判断问答专家是否存在
        getExpert: function(item){
            if(item.expert){
                return item.expert;
            } else {
                return false;
            }
        },
        // 截取分类，最多取三个
        getTagList: function(item){
            if(item && item.length >= 3){
                return item.slice(0,3);
            }else{
                return item;
            }
        },
        // 获取标签第一个id
        toQuestionList: function(){
            this.flag = false
            if(this.detailParams.tlist && this.detailParams.tlist.length != 0){
                this.$router.push({path:"/expertOnline",query:{tagId:this.detailParams.tlist[0].fnTagId}})
            }
        },
        // 校验文章是否收藏过
        checkCollect: function(){
            this.$http.get("/expert/checkCollection", {answerId: this.detailId,crmId:this.userInfo.crm_id}, res => {
                if (res.code == 200) {
                    if (res.data == true) {
                        this.collectShow = true;
                    } else {
                        this.collectShow = false;
                    }
                }
            });
        },
        // 收藏和取消收藏问答
        collect: function (type){
            if($.isEmptyObject(this.detailParams)) return false;
            this.curCollType=type;var that=this;
            localStorage.setItem("expertAdd",this.detailId);
            localStorage.removeItem("courseSign");
            localStorage.removeItem("babyAdd");
            this.wxJsSet.wxHandleBeforeFn(that,that.handleParams,that.collectAjax);
            if(this.collectShow){
                sensors.track("DropQuestion", {
                    question_class1:this.detailParams.ptagNames,
                    question_class2: this.arr.toString(),
                    question_id:this.$route.params.detailId,
                    question_name:this.detailParams.question,
                    expert_name:this.detailParams.expert.realName,
                    expert_hospital:this.detailParams.expert.hospital,
                    expert_level:this.detailParams.expert.position
                });
            }else{
                var date = Date.parse(new Date());
                var id = this.getCookie('xmh_unionid');
                sensors.track("CollectQuestion", {
                    question_class1:this.detailParams.ptagNames,
                    question_class2: this.arr.toString(),
                    question_id:this.$route.params.detailId,
                    question_name:this.detailParams.question,
                    expert_name:this.detailParams.expert.realName,
                    expert_hospital:this.detailParams.expert.hospital,
                    expert_level:this.detailParams.expert.position,
                    itemSetId: this.itemSetId,
                    sceneId: this.sceneId,
                    requestId: this.$md5(date + id),
                    context: this.getCookie('context') ? this.getCookie('context') : ''
                });
            }
        },
        collectAjax:function(){
            this.userInfo=JSON.parse(localStorage.getItem("userInfo"));
            if (this.curCollType) {//收藏
                gio('track', 'QACollectionClick',{'QATitle_var':this.detailParams.question, 'QALabel_var':this.labelName});
                this.$http.get("/expert/addCollection", {answerId: this.detailId,crmId:this.userInfo.crm_id}, res => {
                    if (res.code == 200) {
                        this.$toast({
                            duration:2000,
                            message:'收藏成功',
                            context:this
                        })
                        this.collectShow = true;
                        localStorage.removeItem("expertAdd");
                        this.taskFinishCollect()
                    }
                });
            } else {//取消收藏
                gio('track', 'cancelQACollectionClick',{'QATitle_var':this.detailParams.question, 'QALabel_var':this.labelName});
                this.$http.get("/expert/cancelCollection", {answerId: this.detailId,crmId:this.userInfo.crm_id}, res => {
                    if (res.code == 200) {
                        this.collectShow = false;
                        localStorage.removeItem("expertAdd");
                    }
                });

            }
        },
        // Gio点击分享按钮埋点
        gioShare:function(){
            gio('track', 'QAShareClick',{'QATitle_var':this.detailParams.question, 'QALabel_var':this.labelName});
        },
        getShopId(){
          if (window.location.origin == 'https://mom.feihe.com') {
            // 正式环境物料id和服务id
            this.itemSetId = '146';
            this.sceneId = '305';
          } else {
            // uat环境物料id和服务id
            this.itemSetId = '143';
            this.sceneId = '266';
          }
        },
        // 统计阅读时长
        durationTime(){
          var that = this
          this.lookTimer = setInterval(function(){
            that.readingTime++
          }, 1000);
        },
        // 神策阅读时长上报
        durationTimeReport(){
          var date = Date.parse(new Date());
          var id = this.getCookie('xmh_unionid');
          sensors.track('reading', {
            content_id: this.detailParams.id,
            Reading_position: '专家问答文章详情底部',
            Reading_time: this.readingTime,
            itemSetId: this.itemSetId,
            sceneId: this.sceneId,
            requestId: this.$md5(date + id),
            context: this.getCookie('context') ? this.getCookie('context') : ''
          });
        }
    }
}
</script>
